import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { ITEMS_PER_PAGE, spanishLocaleText } from "./constants";
import LoadingOverlay from "./LoadingOverlay";

interface DocumentSpreadsheetGridProps {
  columns: ColDef[];
  loading: boolean;
  getRowClass: (params: any) => string;
  onCellValueChanged: (event: any) => void;
  onGridReady: (params: any) => void;
  onSortChanged?: (event: any) => void;
  onFilterChanged?: (event: any) => void;
}

const DocumentSpreadsheetGrid: React.FC<DocumentSpreadsheetGridProps> = ({
  columns,
  loading,
  getRowClass,
  onCellValueChanged,
  onGridReady,
  onSortChanged,
  onFilterChanged,
}) => {
  return (
    <div
      className="ag-theme-alpine"
      style={{
        height: 800,
        width: "100%",
        marginBottom: "20px",
        position: "relative",
      }}
    >
      <AgGridReact
        rowModelType="infinite"
        columnDefs={columns}
        getRowClass={getRowClass}
        getRowId={(params) => String(params.data.id)}
        defaultColDef={{
          sortable: true,
          filter: true,
          resizable: true,
          wrapText: false,
          autoHeaderHeight: true,
        }}
        localeText={spanishLocaleText}
        pagination={true}
        paginationPageSize={ITEMS_PER_PAGE}
        cacheBlockSize={ITEMS_PER_PAGE}
        onCellValueChanged={onCellValueChanged}
        onCellEditingStopped={onCellValueChanged}
        onGridReady={onGridReady}
        onSortChanged={onSortChanged}
        onFilterChanged={onFilterChanged}
        theme="legacy"
        stopEditingWhenCellsLoseFocus={true}
        singleClickEdit={true}
        suppressClickEdit={false}
        undoRedoCellEditing={true}
        undoRedoCellEditingLimit={20}
      />
      <LoadingOverlay show={loading} />
    </div>
  );
};

export default DocumentSpreadsheetGrid;
